import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  CHANGE_LESSON_PLAN,
  CHANGE_LESSON_PLAN_FAIL,
  CHANGE_LESSON_PLAN_SUCCESS,
  ChangeLessonPlanActionType
} from '../redux/lessonPlansReducer'

function* ChangeLessonPlanFlow(action: ChangeLessonPlanActionType): Generator<any, void, any> {
  try {
    yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/change_plan`,
      method: 'POST',
      params: {
        lesson_plan_id: action.payload.lessonPlanId,
        lesson_id: action.payload.lessonId
      }
    })
    yield put(CHANGE_LESSON_PLAN_SUCCESS())
  } catch (error) {
    yield put(CHANGE_LESSON_PLAN_FAIL())
    console.log(error)
  }
}

export default function* ChangeLessonPlanSaga(): Generator<any, void, any> {
  yield takeLatest([CHANGE_LESSON_PLAN], ChangeLessonPlanFlow)
}
